import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { siteInfo } from '@/mocks/siteInfo';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <span className="text-2xl font-heading font-bold text-background-50">
                  成<span className="text-primary-400">91</span>
                </span>
              </div>
              <p className="text-background-400 text-sm leading-relaxed mb-4">
                {siteInfo.description}
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="邮箱">
                  <i className="ri-mail-line text-lg"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-background-50 font-heading font-semibold mb-4">内容分类</h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-background-400 hover:text-primary-400 text-sm transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-background-50 font-heading font-semibold mb-4">快速链接</h4>
              <ul className="space-y-2.5">
                <li><Link to="/" className="text-background-400 hover:text-primary-400 text-sm transition-colors">首页</Link></li>
                <li><Link to="/category/shiyong-jiaocheng" className="text-background-400 hover:text-primary-400 text-sm transition-colors">使用教程</Link></li>
                <li><Link to="/category/changjian-wenti" className="text-background-400 hover:text-primary-400 text-sm transition-colors">常见问题</Link></li>
                <li><Link to="/about" className="text-background-400 hover:text-primary-400 text-sm transition-colors">关于我们</Link></li>
                <li><Link to="/category/zuixin-dongtai" className="text-background-400 hover:text-primary-400 text-sm transition-colors">最新动态</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-background-50 font-heading font-semibold mb-4">联系我们</h4>
              <ul className="space-y-2.5">
                <li className="flex items-start gap-2 text-background-400 text-sm">
                  <i className="ri-mail-line mt-0.5 text-background-500"></i>
                  <span>{siteInfo.contact.email}</span>
                </li>
                <li className="flex items-start gap-2 text-background-400 text-sm">
                  <i className="ri-phone-line mt-0.5 text-background-500"></i>
                  <span>{siteInfo.contact.phone}</span>
                </li>
                <li className="flex items-start gap-2 text-background-400 text-sm">
                  <i className="ri-time-line mt-0.5 text-background-500"></i>
                  <span>{siteInfo.contact.workingHours}</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-background-500 text-xs">
              &copy; {new Date().getFullYear()} 成91官方平台 版权所有
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-background-500 hover:text-background-300 text-xs transition-colors">隐私政策</a>
              <a href="#" className="text-background-500 hover:text-background-300 text-xs transition-colors">服务条款</a>
              <a href="#" className="text-background-500 hover:text-background-300 text-xs transition-colors">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}